import type { AuthStaff } from "@elation/api-client/src/stitch-web/models";

import { useActor, useAssertActor } from "@src/shared/providers/actorProvider";

export function useCurrentStaff(): AuthStaff {
  return useAssertActor("staff").user;
}

export function useIsStaff(): boolean {
  return useActor().type === "staff";
}

export function useStaffId(): number {
  return useCurrentStaff().id;
}
